import { useEffect, useMemo, useState } from "react"
import { MainContainer } from "../../components"
import { usePost } from "../../api/reactQueryCustomHooks"
import { apiRoute, linksUrl } from "../../constants/enum"
import { useSelector } from "react-redux"
import { calculateTotalByKey, selectFilter } from "../../Utility/utility"
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { parse } from "@fortawesome/fontawesome-svg-core"

import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { useNavigate } from "react-router-dom"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPrint } from "@fortawesome/free-solid-svg-icons"
import { Button } from "@heroui/react"

const LotWiseDetail = () => {
    const { compCode } = useSelector((state) => state.company);
    const { detailLotNo } = useSelector((state) => state.stockEntry);
    const navigate = useNavigate()
    const { data = [], isPending: isPendingData, mutate: filterData } = usePost({
        url: apiRoute.stockEntry.fetchLotWiseDetail,
        queryKey: "lotwiseDetailtck",
    });

    useEffect(() => {
        if (detailLotNo.length > 0) {
            filterData({
                data: {
                    comp_code: compCode.join(","),
                    trade_of: "P",
                    l_code: detailLotNo.join(","),
                },
            });
        }
    }, [detailLotNo]);

    const lots = data.reduce((acc, item) => {
        if (!acc[item.L_Code]) {
            acc[item.L_Code] = {
                rows: {},
                total: { pcs: 0, wt: 0 },
                stkTotal: { pcs: 0, wt: 0, rate: 0, rateD: 0, amt: 0, amtD: 0 },
            };
        }

        if (!acc[item.L_Code].rows[item.StkAt]) {
            acc[item.L_Code].rows[item.StkAt] = { pcs: 0, wt: 0, rate: 0, rateD: 0, amt: 0, amtD: 0 };
        }
        console.log(item)
        acc[item.L_Code].rows[item.StkAt].pcs += item.Nos;
        acc[item.L_Code].rows[item.StkAt].wt += item.Weight;
        acc[item.L_Code].rows[item.StkAt].rateD += item.AvgRateD;
        acc[item.L_Code].rows[item.StkAt].rate += item.AvgRate;
        acc[item.L_Code].rows[item.StkAt].amtD += item.TotalAmountD;
        acc[item.L_Code].rows[item.StkAt].amt += item.TotalAmount;

        acc[item.L_Code].total.pcs += item.Nos;
        acc[item.L_Code].total.wt += item.Weight;
        const exclude = ['Sale', 'Inward', ""];

        if (!exclude.includes(item.StkAt)) {
            acc[item.L_Code].stkTotal.pcs += item.Nos;
            acc[item.L_Code].stkTotal.wt += item.Weight;
            acc[item.L_Code].stkTotal.rateD += item.AvgRateD;
        }
        //acc[item.L_Code].rows.TOTAL.pcs += item.Nos;
        //acc[item.L_Code].rows.TOTAL.wt += item.Weight;

        return acc;
    }, {});

    Object.keys(lots).forEach(lot => {
        const lotRows = lots[lot].rows;
        const fixedOrder = ["Inward", "Sale", "Memo"];
        const otherRows = Object.keys(lotRows).filter(r => !fixedOrder.includes(r));

        const orderedRows = {};

        // First Inward, then Sale
        fixedOrder.forEach(key => {
            if (lotRows[key]) orderedRows[key] = lotRows[key];
        });

        // Then other dynamic stock locations
        otherRows.forEach(key => {
            orderedRows[key] = lotRows[key];
        });

        // Replace rows with orderedRows
        lots[lot].rows = orderedRows;
    });
    const formatNum = (num) => (typeof num === "number" ? num.toFixed(2) : num);


    const [pdfUrl, setPdfUrl] = useState("");
    const [showModal, setShowModal] = useState(false);


    // const exportPDF = async (lotNo) => {
    //     const card = document.getElementById(lot-${lotNo});
    //     if (!card) return;

    //     // Hide button
    //     const button = card.querySelector("button");
    //     if (button) button.style.display = "none";

    //     // Capture card
    //     const canvas = await html2canvas(card, {
    //         scale: 2,
    //         backgroundColor: "#ffffff"
    //     });

    //     // Restore button
    //     if (button) button.style.display = "block";

    //     const imgData = canvas.toDataURL("image/png");

    //     // Create A4 PDF
    //     const pdf = new jsPDF("p", "mm", "a4");

    //     const pageW = pdf.internal.pageSize.getWidth();   // 210
    //     const pageH = pdf.internal.pageSize.getHeight();  // 297

    //     // 🔒 FIXED CONTENT SIZE (smaller than A4)
    //     const contentW = 80;
    //     const contentH = 80;

    //     // Center it
    //     const x = (pageW - contentW) / 2;
    //     const y = (pageH - contentH) / 2;

    //     pdf.addImage(imgData, "PNG", x, y, contentW, contentH);

    //     window.open(pdf.output("bloburl"), "_blank");
    // };
    const exportPDF = async (lotId) => {
        const card = document.getElementById(`lot-${lotId}`);
        if (!card) return;

        // Hide all buttons inside the card
        const buttons = card.querySelectorAll("button");
        buttons.forEach(btn => (btn.style.display = "none"));

        try {
            // Capture card as canvas with white background like UI
            const canvas = await html2canvas(card, {
                scale: 2,
                backgroundColor: null, // keep the actual UI background
            });

            // Restore buttons
            buttons.forEach(btn => (btn.style.display = "block"));

            const imgData = canvas.toDataURL("image/png");

            // Create PDF
            const pdf = new jsPDF("p", "mm", "a4");
            // Place card top-left with fixed size
            const contentW = 80;
            const contentH = 80;
            const x = 5;
            const y = 5;
            pdf.addImage(imgData, "PNG", x, y, contentW, contentH);

            // Convert to blob URL and show in modal
            const blobUrl = pdf.output("bloburl");
            setPdfUrl(blobUrl);
            setShowModal(true);
        } catch (err) {
            console.error("PDF generation failed:", err);
        }
    };





    const handleClickPrev = () => {
        navigate(linksUrl.rptLotwisePosition)
    }
    const exportAllPDF = async () => {
        const pdf = new jsPDF("p", "mm", "a4");

        const pageW = pdf.internal.pageSize.getWidth();   // 210
        const pageH = pdf.internal.pageSize.getHeight();  // 297

        const cardW = 80;
        const cardH = 80;
        const margin = 10;

        let x = margin;
        let y = margin;

        const lotCards = Object.keys(lots);

        for (let i = 0; i < lotCards.length; i++) {
            const lotNo = lotCards[i];
            const card = document.getElementById(`lot-${lotNo}`);
            if (!card) continue;

            // Hide button
            const button = card.querySelector("button");
            if (button) button.style.display = "none";

            const canvas = await html2canvas(card, {
                scale: 2,
                backgroundColor: "#ffffff"
            });

            // Restore button
            if (button) button.style.display = "block";

            const imgData = canvas.toDataURL("image/png");

            // ➡️ Next row if width exceeded
            if (x + cardW > pageW - margin) {
                x = margin;
                y += cardH + margin;
            }

            // ➡️ New page if height exceeded
            if (y + cardH > pageH - margin) {
                pdf.addPage();
                x = margin;
                y = margin;
            }

            pdf.addImage(imgData, "PNG", x, y, cardW, cardH);

            // Move to next column
            x += cardW + margin;
        }

        pdf.save("All_Lots.pdf");
    };


    const getColor = (stkAt) => {
        if (["Inward", "Sale", ""].includes(stkAt))
            return " text-slate-800 "
        if (["Memo"].includes(stkAt))
            return " text-green-500 "
        else
            return " text-red-500 "
    }
    return (
        <MainContainer pageName="Lot Wise Info" info={[]} breadcrumbs={["Reports", "Lot Wise Info"]}
            prevPage={{
                show: true,
                onClick: handleClickPrev,
            }}
        >



            {showModal && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        background: "rgba(0,0,0,0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            position: "relative",
                            width: "90%",
                            height: "90%",
                            background: "#fff",
                            padding: 10,
                        }}
                    >
                        {/* Close Button */}
                        <button
                            onClick={() => setShowModal(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                zIndex: 10,
                                padding: "5px 10px",
                                background: "#f44336",
                                color: "#fff",
                                border: "none",
                                borderRadius: 4,
                                cursor: "pointer",
                                fontWeight: "bold",
                            }}
                        >
                            Close
                        </button>
                        <iframe
                            src={pdfUrl}
                            style={{ width: "100%", height: "100%", border: "none" }}
                            title="PDF Preview"
                        />
                    </div>
                </div>
            )}

            {lots && Object.keys(lots).length > 0 ? (
                <div className="mx-1 py-5">


                    <div className="w-full  overflow-auto">
                        <div className="min-h-screen bg-slate-50">

                            <div className="flex justify-between mb-2">
                                <h2 className="text-orange-500 font-semibold text-sm">TOAL LOT: {Object.keys(lots).length}</h2>

                                <button
                                    onClick={exportAllPDF}
                                    className="px-2 py-1 bg-slate-600 text-white rounded hover:bg-green-700 text-sm"
                                >
                                    Export All PDF
                                </button>
                            </div>

                            <div className="grid gap-6 md:grid-cols-2 xl:grid-cols-3">

                                {Object.entries(lots).map(([lotNo, lot]) => (
                                    <div
                                        id={`lot-${lotNo}`}
                                        key={lotNo}
                                        className="bg-white rounded-xl shadow border border-slate-200 p-5 relative"
                                    >
                                        {/* Card Header */}
                                        <div className="flex justify-between items-center mb-4">
                                            <h3 className="text-lg font-semibold text-indigo-700">Lot No: {lotNo}</h3>
                                            <div className="text-sm flex gap-2 text-slate-500 items-center">
                                                <Button variant="light" isIconOnly={true} onPress={() => exportPDF(lotNo)} size="sm" >
                                                    <FontAwesomeIcon className="cursor-pointer text-xl   text-orange-500  " icon={faPrint}></FontAwesomeIcon>
                                                </Button>
                                                {/* Total:{" "}
                                                <span className="font-semibold text-slate-700">{lot.total.pcs} pcs</span> */}
                                            </div>
                                        </div>

                                        {/* Details Grid */}
                                        <div className="divide-y divide-slate-200">
                                            <div className="grid grid-cols-5 py-2 font-semibold text-slate-600">
                                                <div>Stock At</div>
                                                <div className="text-right">Pcs</div>
                                                <div className="text-right">Weight</div>
                                                <div className="text-right">Value($)</div>
                                                <div className="text-right">Rate($)</div>
                                            </div>

                                            {Object.entries(lot.rows).map(([stkAt, val]) => (
                                                <div key={stkAt} className="grid grid-cols-5 py-2">
                                                    <div className={` ${getColor(stkAt)} font-medium `}>{stkAt}</div>
                                                    <div className={` ${getColor(stkAt)} text-right text-sm font-semibold `}>
                                                        {val.pcs}
                                                    </div>
                                                    <div className={` ${getColor(stkAt)} text-right text-xs  font-semibold`}>
                                                        {formatNum(val.wt)}
                                                    </div>
                                                    <div className={` ${getColor(stkAt)} text-right text-xs  font-semibold`}>
                                                        {formatNum(val.amtD)}
                                                    </div>
                                                    <div className={` ${getColor(stkAt)} text-right text-xs  font-semibold`}>
                                                        {formatNum(val.rateD)}
                                                    </div>
                                                </div>
                                            ))}
                                        </div>

                                        {/* Footer Total */}
                                        <div className="grid grid-cols-5 mt-2 pt-2 border-t border-slate-200 font-semibold text-indigo-700">
                                            <div className="text-sm">Total Stock</div>
                                            <div className="text-right"> {lot.stkTotal.pcs}<h2></h2> </div>
                                            <div className="text-right">{formatNum(lot.stkTotal.wt)}<h2></h2> </div>
                                            <div className="text-right"><h2></h2></div>
                                            <div className="text-right"><h2></h2></div>
                                            <div className="text-right"><h2></h2></div>

                                        </div>

                                        {/* Export PDF Button */}
                                        {/* <button
                                                onClick={() => exportPDF(lotNo)}
                                                className="absolute top-4 right-4 px-3 py-1 text-white bg-green-600 rounded hover:bg-green-700 text-sm"
                                            >
                                                Export PDF
                                            </button> */}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <h2 className="text-gray-400 p-5 text-sm text-center">No Records Found</h2>
            )}
        </MainContainer>
    );
};



export default LotWiseDetail